module.exports = __webpack_public_path__ + "img/not-interested.567d26c8.svg";